import {createReducer} from "typesafe-actions";
import {ThemeInfoType} from "../../../models/api/codegen/code";
import {CHANGE_THEME} from "../actions";

export const theme = createReducer<ThemeInfoType>({type: "dark", switchTheme: false, force: false})
    .handleAction(CHANGE_THEME, (state, action) => action.payload);